import { useState, useEffect } from 'react';

export function useOneTimeFetch<E>(getData: () => Promise<E>): E | null {
    const [data, setData] = useState<E>(null);
    useEffect(() => {
        getData().then((data) => setData(data));
    }, []);
    return data;
}
